<template>

    <!-- Welcome Modal -->
    <section class="modal modal--welcome">

        <!-- Modal Title -->
        <div class="modal__title">
            <button @click="dismissTour" class="button modal__dismiss">
                <span class="icon icon--small" aria-hidden="true">                
                    <svg class="icon__svg" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="m22.1597929 18.7469764c-2.976-3.0011429-3.144-2.8342857-6.1211428-5.8354286-.4834286-.488-.8857143-.888-1.2411429-1.2377143.2948572-.3188571.6228572-.6811428 1.0011429-1.1234286 2.5554286-2.98171424 3.9451428-2.66857139 6.152-5.91771424.4982857-.73257143.1405714-2.67428572-.9737143-3.44-.5417143-.37142857-1.2068571-.64342857-1.8525714-.52228572-.6457143.12-1.6845715 1.09485715-2.1382857 1.56685715-1.544 1.60457142-2.6994286 2.488-5.2537143 5.46971428-.1714286.20114286-.3314286.384-.4845715.55657143-.3611428-.35542857-.7725714-.76342857-1.26514282-1.26057143-2.97942857-3.00342857-2.736-3.24457143-5.71428571-6.24685714-.11885714-.11885714-.29828572-.28457143-.44-.37828571-.96571429-.63771429-2.70285714-.43885715-3.52457143.376-.46628571.46171428-.256 1.31771428-.25942857 1.97371428-.00228572.65714286.14971428 1.14514286.61257143 1.61142857 2.976 3.00114286 2.92914285 3.04685714 5.90628571 6.04800003.50171429.5051428.91657143.9177143 1.28342857 1.2788571-.42857143.4377143-.92685714.9748572-1.56228571 1.7165714-2.55542857 2.9828572-2.35542857 3.152-4.86285714 6.1748572-.76457143 1.1177143-.75314286 1.8182857.36228571 2.5851428.16342857.112.57257143.8582858.76114286.928 1.06057143.3977143 2.41714285.3074286 3.05828571-.6285714 2.512-3.0137143 2.176-3.2971428 4.72914289-6.2788571.384-.4468572.7142857-.8148572 1.0137143-1.1337143.3634285.3565714.7748571.7657143 1.2708571 1.2651428 2.9794286 3.0034286 3.1211429 2.8628572 6.0982857 5.8662858.4605714.4685714.7737143 1.0674285 1.4068572 1.232.7211428.1874285 1.2925714.4194285 1.76-.0468572.4662857-.4617143.5645714-1.6857143.9874285-2.1885714.5005715-.5931429-.248-1.944-.7097143-2.4102857" fill="#b70062" fill-rule="evenodd"/></svg>
                </span>
                <span class="button__text">Close</span>
            </button>
            <h1>{{ configuration.settings.modal.title }}</h1>
        </div>
        
        <!-- Modal Description -->
        <div v-html="welcomeDescription" class="modal__description"></div>

        <!-- Modal Actions -->
        <div class="modal__actions">
            <button @click="incrementTourStep" :disabled="!hasNextStep" class="button button--large button--icon-right button--touring">
                <span class="button__text">Let's Go</span>
                <span class="icon icon--large icon--inline" aria-hidden="true">
                    <svg class="icon__svg" height="31" viewBox="0 0 29 31" width="29" xmlns="http://www.w3.org/2000/svg"><path d="m11.4281435.38372676c-2.40318085-2.5530712.0780374 8.45133834-1.44829895 8.94026703 0 0-.97984455-1.32399379-9.43698596-.00451782-1.00649714 6.56841063-.31460716 6.44642953-.26483533 13.12929163 2.08488692 2.1961633 2.13711663-.5546881 9.86158274.7323891 1.3333936.3729713-.29002848 6.0734582.6574798 7.8188433 7.8233953-6.0990592 12.4792127-10.1369878 18.2429142-15.5307648-3.1214929-2.4777742-7.0129132-7.39316414-17.6118565-15.08550844z" fill="#b70062" fill-rule="evenodd"/></svg>
                </span>
            </button>
        </div>
    </section>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {

        computed: {
            ...mapGetters({
                configuration: 'configuration',
                hasNextStep: 'hasNextStep',
                touring: 'touring',
                tourStep: 'tourStep',
            }),

            /*
             * Returns the HTML for the description message
             *
             * @return {string}
             */
            welcomeDescription() {
                const descriptionHtml = document.createElement('textarea')
                descriptionHtml.innerHTML = this.configuration.settings.modal.description
                return descriptionHtml.value
            },
        },

        methods: {
            ...mapActions({
                incrementTourStep: 'incrementTourStep',
                setTouring: 'setTouring',
                setTourStep: 'setTourStep',
            }),

            /*
             * Dismisses the tour
             *
             * @returns {void}
             */
            dismissTour() {

                // Set the tour step to negative one
                this.setTourStep(-1)

                // Set touring to false
                this.setTouring(false)
            }
        },
    }
</script>
